import React, { useRef, useState } from "react";
import Input from "../../shared/Form/Input";
import { useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { postData } from "../../../services/API";
import Loading from "../../shared/Loading";

const SendComment = ({ data, reply, user, comment_id, setOpen }) => {
  const { register, getValues, setValue } = useForm();
  const [loading, setLoading] = useState(false);

  const toastSucc = useRef(null);
  const toastErr = useRef(null);
  const sendCommentHandler = () => {
    setLoading(true);
    // const sendCommentHandler = () => {
    //     setSubmitLoading(true);
    //     postData(``, {
    //       ...getValues(),
    //       product_id: data.id,
    //     })
    //       .then((res) => {
    //         setSubmitLoading(false);
    
    //         toast.current.show({
    //           severity: "success",
    //           summary: "دیدگاه شما موفقیت ثبت شد",
    //           detail: "منتظر تایید مدیریت بمانید.",
    //           life: 3000,
    //         });
    
    //         setValue("message", "");
    //         setValue("full_name", "");
    //         setValue("email", "");
    //         setSave(false);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         setSubmitLoading(false);
    //       });
    //   };
    postData(`/shop/comment/save`, {
      ...getValues(),
      ...(reply && { parent_id: comment_id }),
      product_id: data,
    })
      .then((res) => {
        reply &&
          setTimeout(() => {
            setOpen(false);
          }, 3000);

        setValue("message", "");
        setLoading(false);
        toastSucc.current.show({
          severity: "success",
          summary: "دیدگاه شما موفقیت ثبت شد",
          detail: "منتظر تایید مدیریت بمانید.",
          life: 3000,
        });
      })
      .catch((err) => {
        setLoading(false);
        toastErr.current.show({
          severity: "error",
          summary: " وارد حساب کاربری کاربری شوید",
          detail: "برای ثبت دیدگاه وارد شوید.",
          life: 3000,
        });
      });
  };

  return (
    <div className="flex flex-col gap-4">
      <Toast ref={toastSucc} />
      <Toast ref={toastErr} />

      {reply && (
        <div className="flex items-center gap-2">
          <span className="block w-[14px] h-[6px] bg-yellow-700 rounded-full"></span>
          <h3 className="text-lg text-gray-200 font-black">{`پاسخ به ${
            user.name + " " + user.family_name
          }`}</h3>
        </div>
      )}

      <Input
        label={"دیدگاه"}
        register={{ ...register("message") }}
        labelClass={"product-comment-label relative pr-5"}
        placeHolder={"دیدگاه خود را بنویسید"}
        className={`!h-44 ${reply && "!bg-gray-800 !border-gray-700"}`}
      />

      <button
        onClick={sendCommentHandler}
        className="bg-gradient-to-tl from-green-600 to-green-300 text-white w-full h-11 rounded-lg shadow-lg shadow-test transition-all duration-300"
      >
        {loading ? (
          <Loading color={"before:!bg-white"} />
        ) : (
          <span>ثبت دیدگاه</span>
        )}
      </button>
    </div>
  );
};

export default SendComment;
